/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How Grand Prize entries are calculated
 * @export
 */
export const GrandPrizeEntrySource = {
    ALL_SEGMENTS: 'ALL_SEGMENTS',
    CUSTOM: 'CUSTOM'
} as const;
export type GrandPrizeEntrySource = typeof GrandPrizeEntrySource[keyof typeof GrandPrizeEntrySource];


export function instanceOfGrandPrizeEntrySource(value: any): boolean {
    for (const key in GrandPrizeEntrySource) {
        if (Object.prototype.hasOwnProperty.call(GrandPrizeEntrySource, key)) {
            if (GrandPrizeEntrySource[key as keyof typeof GrandPrizeEntrySource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GrandPrizeEntrySourceFromJSON(json: any): GrandPrizeEntrySource {
    return GrandPrizeEntrySourceFromJSONTyped(json, false);
}

export function GrandPrizeEntrySourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrandPrizeEntrySource {
    return json as GrandPrizeEntrySource;
}

export function GrandPrizeEntrySourceToJSON(value?: GrandPrizeEntrySource | null): any {
    return value as any;
}

export function GrandPrizeEntrySourceToJSONTyped(value: any, ignoreDiscriminator: boolean): GrandPrizeEntrySource {
    return value as GrandPrizeEntrySource;
}

